import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { AccessTokenActions, AccessTokenState } from '~/store/accessToken/accessToken'

export default defineComponent({
  name: 'AccessTokenMixin',

  computed: {
    ...(mapState<AccessTokenState>('accessToken/accessToken', {
      userAccessTokenList: (state: AccessTokenState) => state.userAccessTokenList,
      totalUserAccessTokens: (state: AccessTokenState) => state.totalUserAccessTokens,
      currentUserAccessToken: (state: AccessTokenState) => state.currentUserAccessToken
    }) as {
      userAccessTokenList: () => AccessTokenState['userAccessTokenList']
      totalUserAccessTokens: () => AccessTokenState['totalUserAccessTokens']
      currentUserAccessToken: () => AccessTokenState['currentUserAccessToken']
    })
  },

  methods: {
    ...mapActions('accessToken/accessToken', {
      fetchAccessTokenList: AccessTokenActions.FETCH_ACCESS_TOKEN_LIST,
      fetchSingleAccessToken: AccessTokenActions.FETCH_ACCESS_TOKEN,
      deleteAccessToken: AccessTokenActions.DELETE_ACCESS_TOKEN,
      deleteAllAccessTokens: AccessTokenActions.DELETE_ALL_ACCESS_TOKEN,
      createUserAccessToken: AccessTokenActions.CREATE_USER_ACCESS_TOKEN
    })
  }
})
